<template>
  <div class="hot-comment-list">
    <div class="comment-list-item" v-for="(item, index) in hotComments"  :key="index">
        <div class="comment-user-img"  :style="'background-image:url('+ coverPhoto.url+')'"></div>
        <div class="comment-list-desc">
            <div class="comment-content">
                <p>{{item.name}}</p>
                <p>{{item.content}}</p>
            </div>
            <div class="desc-footer">
                 <p>
                    <span>今天</span>
                    <span>15:30</span> 
                 </p>
                 <div >
                     <div></div>
                    <span>200</span> 
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import reply from '@/assets/img/reply.png'
import Comment from '@/components/post/Comment'
export default {
  name: 'hot-comment-list',
  data () {
    return {
      reply: null,
      likeUrl: '../assets/img/like.png',
      replyUrl: reply,
       coverPhoto:{
          url:'http://api.kingdee.com/kdrive/user/file/thumbnail?file_id=46042344&client_id=200547&scode=bnMvd1JqdEZSNmlVdDFfcl9QOHl3&height=200&sign=3fb1e6d59626e0da8f4e7e5284b0e829ec57ccb9'
       },
      hotComments:[
          { 
            name:"韦佳妮",
            time:'2019.5.29',
            content:"文章真好，文章真棒，真不错，很优秀，十分优秀"
          },
          { 
            name:"曹阿群",
            time:'2019.5.29',
            content:"最近在研究UML，个人觉得【待 办】的描述，可以用带泳道的活 动图和针对于“待办”对象的状 态机图描述起来会更加清晰流畅， 个人愚见~"
          },
         { 
            name:"卢文婵",
            time:'2019.5.29',
            content:"之前由于一直在做电商，对共享 并未做深入了解。有幸这段时间 开始做一款共享APP，因此也就 对共享产品做了一些调研，特将 这段时间共享的产品信息做个初 步总结。"
        },

      ]
    }
  },
  methods: {
   
  }
}
</script>
<style lang="scss" >
  .hot-comment-list {
       width:280px;
       border-radius:6px;
       border:1px solid rgba(234,234,234,1);
       padding-bottom: 22px;
       
     >.comment-list-item:nth-child(1n+2){
      margin-top: 25px;
   }
   >.comment-list-item{
       display: flex;
       flex-direction: row;
     >.comment-user-img{
        width:40px;
        height:40px;
        border-radius: 50%;
        margin: 16px 11px 0px 12px;
        background-size: cover;
     }
     >.comment-list-desc{
            width:205px;
            // height: 200px;
            border-radius:6px;
            margin-top: 16px;
            
           
         >.comment-content{
              text-align: left;
              padding: 12px 11px 12px 14px;
              background:rgba(248,248,248,1);
           >p:nth-child(2){
                font-size:12px;
                font-family:MicrosoftYaHei;
                color:rgba(51,51,51,1);
                line-height:20px;
                margin: 0;
                margin-top: 2px;
           }
           >p:nth-child(1){
               font-size:14px;
                font-family:MicrosoftYaHei-Bold;
                font-weight:bold;
                color:rgba(51,51,51,1);
                line-height:19px;
                margin: 0px;
               
           }
         }
         >.desc-footer{
             text-align: left;
             padding-top: 6px;
             display: flex;
            flex-direction: row;
            >p{
                font-size:12px;
                font-family:MicrosoftYaHei;
                color:rgba(153,153,153,1);
                line-height:16px;
                margin: 0px;
                margin-left: 15px;
                 >span:nth-child(1){

                 }
                 >span:nth-child(2){
                     margin-left: 9px;
                 }
            }
             >div{
                    font-size:12px;
                    font-family:MicrosoftYaHei-Bold;
                    font-weight:bold;
                    color:rgba(153,153,153,1);
                    line-height:16px;
                  
                    margin-left: 59px;
                     display: flex;
                    flex-direction: row;
                 >div{
                     width: 20px;
                     height: 20px;
                     margin-top: -2px;
                    //  background-color: lightgoldenrodyellow;
                    background-image: url("~@/assets/img/like.png");
                    background-size: cover;

                 }
                 >span{
                     margin-left: 9px;
                 }
             }
         }
     }
   }
}
</style>


